module.exports = __webpack_public_path__ + "958cfea5742c3f8cbdbbb58309204a33.fbx";